/* =========================================================
   BERRYANDBLUSH — apple-design.js (20.10.2026, Apple Design Review)
   Läuft nach global.js und mobile-enhancements.js (defer).
   1. Drawer (Warenkorb, Menü): 1:1 mit dem Finger wischbar, Gummiband am Rand,
      Loslassen mit Geschwindigkeit und Impuls-Projektion, jederzeit greifbar.
   2. Produktgalerie: Bilder wischen (Touch), gleiche Physik.
   3. Header: Kante erst beim Scrollen, mobil Social-Leiste einklappen.
   4. Feedback beim Hinzufügen: Zähler federt, kurze Vibration (wo möglich).
   Reduced Motion: Übergänge ohne Federn, kein Einklappen.
   ========================================================= */
(function () {
  'use strict';

  var root = document.documentElement;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

  function clamp(v, a, b) { return Math.min(b, Math.max(a, v)); }
  // Gummiband: je weiter über die Grenze, desto weniger folgt das Element
  function rubber(o, d) { return (o * d * 0.55) / (d + 0.55 * Math.abs(o)); }
  // Auslaufposition aus Loslass-Geschwindigkeit (px/s), wie beim Scrollen
  function project(v) { return (v / 1000) * 0.998 / (1 - 0.998); }
  function velocity(h) {
    var n = h.length;
    if (n < 2) return 0;
    var a = h[Math.max(0, n - 4)], b = h[n - 1];
    var dt = (b.t - a.t) / 1000;
    return dt > 0 ? (b.x - a.x) / dt : 0;
  }

  // Kritisch gedämpfte Feder (response = Sekunden), übernimmt die Startgeschwindigkeit
  function spring(from, to, v0, response, onUpdate, onDone) {
    var w = (2 * Math.PI) / response, x = from - to, v = v0, last = performance.now(), raf, stopped = false;
    function step(now) {
      if (stopped) return;
      var dt = Math.min((now - last) / 1000, 1 / 30), h = dt / 4, i;
      last = now;
      for (i = 0; i < 4; i++) { v += (-w * w * x - 2 * w * v) * h; x += v * h; }
      if (Math.abs(x) < 0.5 && Math.abs(v) < 8) { onUpdate(to); if (onDone) onDone(); return; }
      onUpdate(to + x);
      raf = requestAnimationFrame(step);
    }
    raf = requestAnimationFrame(step);
    return function () { stopped = true; cancelAnimationFrame(raf); };
  }

  function swallowNextClick() {
    function swallow(e) { e.stopPropagation(); e.preventDefault(); window.removeEventListener('click', swallow, true); }
    window.addEventListener('click', swallow, true);
    setTimeout(function () { window.removeEventListener('click', swallow, true); }, 80);
  }

  /* ---------- 1. Drawer wischbar ---------- */
  function drawerSwipe(panel, overlay, dir, isOpen, close) {
    if (!panel) return;
    var cur = 0, stop = null, drag = null, hist = [];

    function width() { return panel.offsetWidth || 320; }
    function apply(x) {
      cur = x;
      panel.style.transform = 'translate3d(' + x + 'px,0,0)';
      if (overlay) overlay.style.opacity = String(1 - clamp(Math.abs(x) / width(), 0, 1));
    }
    function reset() {
      panel.style.transition = panel.style.transform = '';
      if (overlay) { overlay.style.transition = overlay.style.opacity = ''; }
      cur = 0;
    }
    function finish(closeIt) { if (closeIt) close(); reset(); }

    panel.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'mouse' || !isOpen()) return;
      drag = { id: e.pointerId, x0: e.clientX, y0: e.clientY, base: cur, active: false };
      hist = [{ t: e.timeStamp, x: e.clientX }];
    });

    panel.addEventListener('pointermove', function (e) {
      if (!drag || e.pointerId !== drag.id) return;
      var dx = e.clientX - drag.x0, dy = e.clientY - drag.y0;
      if (!drag.active) {
        // Absicht erkennen: erst nach ~10px, und nur wenn horizontal
        if (Math.abs(dy) > 10 && Math.abs(dy) >= Math.abs(dx)) { drag = null; return; }
        if (Math.abs(dx) < 10) return;
        drag.active = true;
        if (stop) { stop(); stop = null; }   // mitten in der Bewegung greifen
        drag.base = cur;                     // ab der aktuellen Bildschirmposition
        drag.x0 = e.clientX;
        dx = 0;
        try { panel.setPointerCapture(e.pointerId); } catch (err) {}
        panel.style.transition = 'none';
        if (overlay) overlay.style.transition = 'none';
      }
      var raw = drag.base + dx, t = raw * dir;
      apply(t >= 0 ? raw : -dir * rubber(-t, width()));
      hist.push({ t: e.timeStamp, x: e.clientX });
      if (hist.length > 6) hist.shift();
    });

    function release(e) {
      if (!drag || e.pointerId !== drag.id) return;
      var d = drag; drag = null;
      if (!d.active) return;
      swallowNextClick();
      var v = velocity(hist), w = width();
      var closeIt = (cur + project(v)) * dir > w * 0.5;
      if (reduce.matches) { finish(closeIt); return; }
      stop = spring(cur, closeIt ? dir * w : 0, v, 0.4, apply, function () { stop = null; finish(closeIt); });
    }
    panel.addEventListener('pointerup', release);
    panel.addEventListener('pointercancel', release);
  }

  /* ---------- 2. Produktgalerie wischbar ---------- */
  function gallerySwipe(g) {
    var wrap = g.querySelector('.product__main-image');
    var thumbs = Array.prototype.slice.call(g.querySelectorAll('[data-gallery-thumb]'));
    if (!wrap || thumbs.length < 2 || typeof g.select !== 'function') return;
    var cur = 0, stop = null, drag = null, hist = [];

    function img() { return wrap.querySelector('[data-gallery-main]'); }
    function index() {
      for (var i = 0; i < thumbs.length; i++) { if (thumbs[i].classList.contains('is-active')) return i; }
      return 0;
    }
    function apply(x) { cur = x; var el = img(); if (el) el.style.transform = 'translate3d(' + x + 'px,0,0)'; }
    function clear() { var el = img(); if (el) { el.style.transform = ''; el.style.transition = ''; } cur = 0; }

    wrap.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'mouse') return;
      drag = { id: e.pointerId, x0: e.clientX, y0: e.clientY, base: cur, active: false };
      hist = [{ t: e.timeStamp, x: e.clientX }];
    });
    wrap.addEventListener('pointermove', function (e) {
      if (!drag || e.pointerId !== drag.id) return;
      var dx = e.clientX - drag.x0, dy = e.clientY - drag.y0;
      if (!drag.active) {
        if (Math.abs(dy) > 10 && Math.abs(dy) >= Math.abs(dx)) { drag = null; return; }
        if (Math.abs(dx) < 10) return;
        drag.active = true;
        if (stop) { stop(); stop = null; }
        drag.base = cur; drag.x0 = e.clientX; dx = 0;
        try { wrap.setPointerCapture(e.pointerId); } catch (err) {}
      }
      var raw = drag.base + dx, i = index(), w = wrap.offsetWidth || 320;
      // an den Enden Gummiband, sonst 1:1
      if ((raw > 0 && i === 0) || (raw < 0 && i === thumbs.length - 1)) {
        raw = raw > 0 ? rubber(raw, w) : -rubber(-raw, w);
      }
      apply(raw);
      hist.push({ t: e.timeStamp, x: e.clientX });
      if (hist.length > 6) hist.shift();
    });
    function release(e) {
      if (!drag || e.pointerId !== drag.id) return;
      var d = drag; drag = null;
      if (!d.active) return;
      swallowNextClick();
      var v = velocity(hist), w = wrap.offsetWidth || 320, i = index();
      var p = cur + project(v), next = i;
      if (p < -w * 0.3 && i < thumbs.length - 1) next = i + 1;
      else if (p > w * 0.3 && i > 0) next = i - 1;
      if (next === i) {
        if (reduce.matches) { clear(); return; }
        stop = spring(cur, 0, v, 0.4, apply, function () { stop = null; clear(); });
        return;
      }
      if (reduce.matches) { g.select(next); clear(); return; }
      var s = next > i ? 1 : -1;
      // altes Bild gleitet hinaus, neues kommt von der Gegenseite herein
      stop = spring(cur, -s * w, v, 0.22, apply, function () {
        g.select(next);
        apply(s * w);
        stop = spring(s * w, 0, 0, 0.4, apply, function () { stop = null; clear(); });
      });
    }
    wrap.addEventListener('pointerup', release);
    wrap.addEventListener('pointercancel', release);
  }

  /* ---------- 3. Header: Kante und Einklappen ---------- */
  function headerBehavior() {
    var header = document.querySelector('.header');
    if (!header) return;
    var util = header.querySelector('.header__utility');
    var mq = window.matchMedia('(max-width: 767px)');
    var lastY = window.pageYOffset || 0, compact = false, ticking = false;

    function measure() { root.style.setProperty('--bb-utility-h', (util ? util.offsetHeight : 0) + 'px'); }
    function update() {
      var y = window.pageYOffset || 0, dy = y - lastY;
      root.classList.toggle('bb-stuck', y > 4);
      if (mq.matches && util && !reduce.matches) {
        if (y > 120 && dy > 6) compact = true;
        else if (dy < -6 || y < 40) compact = false;
      } else { compact = false; }
      if (Math.abs(dy) > 6) lastY = y;
      root.classList.toggle('bb-compact', compact);
      ticking = false;
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { ticking = true; requestAnimationFrame(update); }
    }, { passive: true });
    window.addEventListener('resize', measure);
    header.addEventListener('focusin', function () { compact = false; root.classList.remove('bb-compact'); });
    measure();
    update();
  }

  /* ---------- 4. Feedback beim Hinzufügen ---------- */
  function cartFeedback() {
    if (!window.CartStore) return;
    var last = null;
    window.CartStore.subscribe(function (c) {
      if (!c) return;
      if (last !== null && c.item_count > last && !reduce.matches) {
        if (navigator.vibrate) navigator.vibrate(12);
        Array.prototype.forEach.call(document.querySelectorAll('.header__cart-count'), function (el) {
          el.classList.remove('bb-bump');
          void el.offsetWidth;
          el.classList.add('bb-bump');
        });
      }
      last = c.item_count;
    });
  }

  function init() {
    var cart = document.querySelector('cart-drawer');
    if (cart) {
      drawerSwipe(cart, document.querySelector('.cart-drawer__overlay'), 1,
        function () { return cart.classList.contains('is-open'); },
        function () { if (typeof cart.close === 'function') cart.close(); });
    }
    var menu = document.querySelector('menu-drawer');
    if (menu) {
      drawerSwipe(menu.querySelector('.menu-drawer__panel'), menu.querySelector('.menu-drawer__overlay'), -1,
        function () { return menu.classList.contains('is-open'); },
        function () { if (typeof menu.close === 'function') menu.close(); });
    }
    var gallery = document.querySelector('product-gallery');
    if (gallery) gallerySwipe(gallery);
    headerBehavior();
    cartFeedback();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
/* END apple-design.js */
